import { render, staticRenderFns } from "./AgentCommonProduct.vue?vue&type=template&id=21f1d8d4&"
import script from "./AgentCommonProduct.vue?vue&type=script&lang=js&"
export * from "./AgentCommonProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports